import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { MessageCircle, Copy } from "lucide-react";
import { useState, useEffect } from "react";

const APP_URL = window.location.origin;

const defaultMsg = (user) => {
  const roleLabel = user.role === "Promoter" ? "Promoter" : user.role;
  return `Hi ${user.name}, welcome to *Coke @9* — the operations app for your Reliance store.
Your login: +91 ${user.phone}
Open the app here: ${APP_URL}
OTP: enter *123456* (demo) or wait for an SMS once we go live.
Any questions? Reply here.
— BBIPL`;
};

export const WhatsAppLinkDialog = ({ user, open, onOpenChange }) => {
  const [msg, setMsg] = useState("");
  useEffect(() => { if (user) setMsg(defaultMsg(user)); }, [user]);
  if (!user) return null;

  const link = `https://wa.me/91${user.phone}?text=${encodeURIComponent(msg)}`;

  const copy = () => {
    navigator.clipboard.writeText(link);
    toast.success("Link copied");
  };
  const open_ = () => {
    window.open(link, "_blank");
    toast.success("Opening WhatsApp…");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="whatsapp-dialog" className="rounded-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <MessageCircle className="h-5 w-5 text-green-600" />
            Onboard via WhatsApp — {user.name}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="text-sm text-gray-600">
            To: <span className="font-semibold">+91 {user.phone}</span>
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-[0.1em] text-gray-500">Message (edit if needed)</label>
            <Textarea data-testid="whatsapp-message" rows={8} value={msg} onChange={(e) => setMsg(e.target.value)} className="mt-1 font-mono text-xs" />
          </div>
          <div className="rounded-lg bg-gray-50 p-3">
            <div className="text-[10px] font-bold uppercase tracking-widest text-gray-500 mb-1">Link preview</div>
            <div className="text-[11px] text-gray-700 break-all font-mono">{link}</div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" data-testid="copy-whatsapp-btn" onClick={copy}>
            <Copy className="h-4 w-4 mr-2" /> Copy link
          </Button>
          <Button data-testid="open-whatsapp-btn" onClick={open_} className="bg-green-600 hover:bg-green-700">
            <MessageCircle className="h-4 w-4 mr-2" /> Open in WhatsApp
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
